(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      //this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);



  // Cart drawer readiness handler - immediate execution
  (function() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    let cartDrawerReady = false;
    let cartDrawerCheckInterval = null;
    let initialLoadDelay = true; // Prevent clicks for first 2 seconds

    // Function to check if cart drawer is ready
    function checkCartDrawerReady() {
      // Check if cart drawer element exists and is properly initialized
      const cartDrawer = document.querySelector('cart-drawer');
      const cartDrawerScript = document.querySelector('script[src*="cart-drawer.js"]');
      
      if (cartDrawer && cartDrawerScript) {
        // Additional check: see if the cart drawer has the expected structure
        const cartDrawerContent = cartDrawer.querySelector('.drawer__inner');
        if (cartDrawerContent) {
          cartDrawerReady = true;
          cartIcon.setAttribute('data-cart-drawer-ready', 'true');
          if (cartDrawerCheckInterval) {
            clearInterval(cartDrawerCheckInterval);
            cartDrawerCheckInterval = null;
          }
          return true;
        }
      }
      return false;
    }

    // Handle cart icon clicks immediately
    cartIcon.addEventListener('click', function(e) {
      // Prevent clicks during initial load delay
      if (initialLoadDelay) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Cart drawer not ready - preventing navigation');
        return false;
      }

      // If cart drawer is not ready, prevent default and show loading state
      if (!cartDrawerReady) {
        e.preventDefault();
        e.stopPropagation();
        
        // Add loading state
        cartIcon.style.opacity = '0.6';
        cartIcon.style.pointerEvents = 'none';
        
        // Wait a bit and try again
        setTimeout(() => {
          cartIcon.style.opacity = '1';
          cartIcon.style.pointerEvents = 'auto';
          
          // If still not ready, allow normal navigation
          if (!cartDrawerReady) {
            window.location.href = cartIcon.href;
          }
        }, 500);
        
        return false;
      }
    });

    // Initial check
    if (!checkCartDrawerReady()) {
      // If not ready, check every 100ms for up to 5 seconds
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds at 100ms intervals
      
      cartDrawerCheckInterval = setInterval(() => {
        attempts++;
        if (checkCartDrawerReady() || attempts >= maxAttempts) {
          if (cartDrawerCheckInterval) {
            clearInterval(cartDrawerCheckInterval);
            cartDrawerCheckInterval = null;
          }
        }
      }, 100);
    }

    // Listen for cart drawer events to know when it's ready
    document.addEventListener('cart:ready', function() {
      cartDrawerReady = true;
      cartIcon.setAttribute('data-cart-drawer-ready', 'true');
    });

    // Remove initial load delay after 2 seconds
    setTimeout(() => {
      initialLoadDelay = false;
      console.log('Initial load delay removed - cart icon now functional');
    }, 2000);

    // Fallback: if cart drawer script loads, mark as ready after a delay
    if (document.querySelector('script[src*="cart-drawer.js"]')) {
      setTimeout(() => {
        if (!cartDrawerReady) {
          cartDrawerReady = true;
          cartIcon.setAttribute('data-cart-drawer-ready', 'true');
        }
      }, 1500);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
